<div class="loading-container">
  <div class="logo-container">
    <div class="loading-dots">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    <img class="logo" alt="Daydic Logo" src="assets/media/logos/logo.png" />
    <div class="loading-dots">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
</div>
